module.exports = __webpack_public_path__ + "img/api-screenshot.d6943546.png";